import { jsx } from 'react/jsx-runtime';
import 'luxon';
import '../../client-components/ThemeProvider.js';
import 'react';
import '../../client-components/Tabs/Tabs.module.scss.js';
import 'classnames';
import '../Table/components/HeaderCell.module.scss.js';
import '../layout/Flex/Flex.js';
import '../layout/Row/Row.module.scss.js';
import '../layout/Stack/Stack.js';
import '../layout/Box/Box.js';
import '../icons/ActivityIcon.js';
import '../icons/ArrowDownIcon.js';
import '../icons/ArrowDownRightCircleIcon.js';
import '../icons/ArrowLeftAlignIcon.js';
import '../icons/ArrowLeftIcon.js';
import '../icons/ArrowRightAlignIcon.js';
import '../icons/ArrowRightIcon.js';
import '../icons/ArrowUpIcon.js';
import '../icons/ArrowUpRightCircleIcon.js';
import '../icons/ArrowsAngleExpandIcon.js';
import '../icons/BankIcon.js';
import '../icons/CheckIcon.js';
import '../icons/ChevronDownIcon.js';
import '../icons/ChevronRightIcon.js';
import '../icons/ChevronUpIcon.js';
import '../icons/CopyIcon.js';
import '../icons/CrossIcon.js';
import '../icons/DaiIcon.js';
import '../icons/DangerIcon.js';
import '../icons/DownSortIcon.js';
import '../icons/ExclamationTriangleIcon.js';
import '../icons/ExpandKpiIcon.js';
import '../icons/EyeIcon.js';
import '../icons/EyeSlashIcon.js';
import '../icons/Grid1x2Icon.js';
import '../icons/InfoCircleIcon.js';
import '../icons/ListIcon.js';
import '../icons/LockIcon.js';
import '../icons/MediumIcon.js';
import '../icons/MoonIcon.js';
import '../icons/PiggyBankIcon.js';
import '../icons/QuestionMarkCircleIcon.js';
import '../icons/ShieldIcon.js';
import '../icons/SunIcon.js';
import '../icons/UpSortIcon.js';
import '../icons/XIcon.js';
import '../Table/Table.module.scss.js';
import '../Table/components/TableRow.module.scss.js';
import '../Table/components/Pagination.module.scss.js';
import '../Text/Text.js';
import '../Table/components/TableCell/TableCell.module.scss.js';
import '../Card/Card.module.scss.js';
import '../List/List.module.scss.js';
import '../ErrorBox/ErrorBox.module.scss.js';
import '../InfoBox/InfoBox.module.scss.js';
import '../KpiCard/KpiCard.module.scss.js';
import '../TrendValue/TrendValue.module.scss.js';
import '../Modal/Modal.module.scss.js';
import '../Badge/Badge.module.scss.js';
import '../HeatmapActivity/HeatmapActivity.module.scss.js';
import '../../client-components/Tooltip/Tooltip.js';
import Switch from '../Switch/Switch.js';
import '@blockanalitica/ui';
import '../Select/Select.module.scss.js';
import '../pictograms/EthPictogram.js';
import '../pictograms/EtherScanPictogram.js';
import '../pictograms/DebankPictogram.js';
import '../pictograms/ZapperPictogram.js';
import '../pictograms/DaiPictogram.js';
import 'react-loading-skeleton';
import '../../client-components/ThemeModeSelector/ThemeModeSelector.module.scss.js';
import '../../client-components/ExpandableCard/ExpandableCard.module.scss.js';
import '../../client-components/ExpandableKpiCard/ExpandableKpiCard.module.scss.js';
import '../../client-components/CopyButton/CopyButton.module.scss.js';
import 'ethereum-blockies-base64';
import '../../client-components/WalletAddress/WalletAddress.module.scss.js';
import '../../client-components/filters/TextSearchFilter/TextSearchFilter.module.scss.js';
import '../../client-components/sidebars/FixedSidebar/components/MobileTopNavBar/MobileTopNavbar.module.scss.js';
import '../../client-components/sidebars/FixedSidebar/components/Sidebar/Sidebar.module.scss.js';
import '../../client-components/sidebars/FixedSidebar/FixedSidebar.module.scss.js';
import '../../client-components/sidebars/CollapsableSidebar/CollapsableSidebar.module.scss.js';
import '../../client-components/FormattedCurrency/FormattedCurrency.js';
import '../../client-components/FormattedPercentage/FormattedPercentage.js';
import '../../client-components/CurrencyValue/CurrencyValue.module.scss.js';
import '../../client-components/PercentageValue/PercentageValue.module.scss.js';
import '../../client-components/DisplaySwitch/DisplaySwitch.module.scss.js';
import 'lodash';
import '../../client-components/charts/ChartJS.js';
import '../../client-components/charts/components/ChartKpis/ChartKpis.module.scss.js';
import '../../client-components/charts/components/ChartSingleValueIndicator/ChartSingleValueIndicator.module.scss.js';
import '../../client-components/charts/BarChart/BarChart.module.scss.js';
import '../../client-components/charts/LineChart/LineChart.module.scss.js';
import '../../client-components/charts/AreaChart/AreaChart.module.scss.js';
import 'randomcolor';
import 'd3';
import '../../client-components/Checkbox/Checkbox.module.scss.js';

function CurrencyFilter({ filtersApplied, updateFilters, currency1, currency2, filterField = 'currency', ...rest }) {
    return (jsx(Switch, { activeOption: filtersApplied[filterField] === currency2.value, onChange: () => updateFilters({
            [filterField]: filtersApplied[filterField] === currency1.value
                ? currency2.value
                : currency1.value
        }), optionOne: currency1.displayValue, optionTwo: currency2.displayValue, height: "1.65rem", ...rest }));
}

export { CurrencyFilter as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3VycmVuY3lGaWx0ZXIuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3NlcnZlci1jb21wb25lbnRzL2ZpbHRlcnMvQ3VycmVuY3lGaWx0ZXIudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFJlYWN0Tm9kZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IFN3aXRjaCB9IGZyb20gJy4uLy4uLy4uJztcbmltcG9ydCB7IFN3aXRjaFByb3BzIH0gZnJvbSAnLi4vU3dpdGNoL1N3aXRjaCc7XG5cbmV4cG9ydCB0eXBlIEN1cnJlbmN5ID0ge1xuICB2YWx1ZTogc3RyaW5nO1xuICBkaXNwbGF5VmFsdWU6IHN0cmluZyB8IFJlYWN0Tm9kZTtcbn07XG5cbmludGVyZmFjZSBDdXJyZW5jeUZpbHRlclByb3BzIGV4dGVuZHMgUGFydGlhbDxTd2l0Y2hQcm9wcz4ge1xuICBmaWx0ZXJzQXBwbGllZDogUmVjb3JkPHN0cmluZywgc3RyaW5nPjtcbiAgdXBkYXRlRmlsdGVyczogKC4uLmFyZ3M6IHVua25vd25bXSkgPT4gdm9pZDtcbiAgY3VycmVuY3kxOiBDdXJyZW5jeTtcbiAgY3VycmVuY3kyOiBDdXJyZW5jeTtcbiAgZmlsdGVyRmllbGQ/OiBzdHJpbmc7XG59XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIEN1cnJlbmN5RmlsdGVyKHtcbiAgZmlsdGVyc0FwcGxpZWQsXG4gIHVwZGF0ZUZpbHRlcnMsXG4gIGN1cnJlbmN5MSxcbiAgY3VycmVuY3kyLFxuICBmaWx0ZXJGaWVsZCA9ICdjdXJyZW5jeScsXG4gIC4uLnJlc3Rcbn06IEN1cnJlbmN5RmlsdGVyUHJvcHMpIHtcbiAgcmV0dXJuIChcbiAgICA8U3dpdGNoXG4gICAgICBhY3RpdmVPcHRpb249e2ZpbHRlcnNBcHBsaWVkW2ZpbHRlckZpZWxkXSA9PT0gY3VycmVuY3kyLnZhbHVlfVxuICAgICAgb25DaGFuZ2U9eygpID0+XG4gICAgICAgIHVwZGF0ZUZpbHRlcnMoe1xuICAgICAgICAgIFtmaWx0ZXJGaWVsZF06XG4gICAgICAgICAgICBmaWx0ZXJzQXBwbGllZFtmaWx0ZXJGaWVsZF0gPT09IGN1cnJlbmN5MS52YWx1ZVxuICAgICAgICAgICAgICA/IGN1cnJlbmN5Mi52YWx1ZVxuICAgICAgICAgICAgICA6IGN1cnJlbmN5MS52YWx1ZVxuICAgICAgICB9KVxuICAgICAgfVxuICAgICAgb3B0aW9uT25lPXtjdXJyZW5jeTEuZGlzcGxheVZhbHVlfVxuICAgICAgb3B0aW9uVHdvPXtjdXJyZW5jeTIuZGlzcGxheVZhbHVlfVxuICAgICAgaGVpZ2h0PVwiMS42NXJlbVwiXG4gICAgICB7Li4ucmVzdH1cbiAgICAvPlxuICApO1xufVxuIl0sIm5hbWVzIjpbIl9qc3giXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBaUJ3QixTQUFBLGNBQWMsQ0FBQyxFQUNyQyxjQUFjLEVBQ2QsYUFBYSxFQUNiLFNBQVMsRUFDVCxTQUFTLEVBQ1QsV0FBVyxHQUFHLFVBQVUsRUFDeEIsR0FBRyxJQUFJLEVBQ2EsRUFBQTtJQUNwQixRQUNFQSxJQUFDLE1BQU0sRUFBQSxFQUNMLFlBQVksRUFBRSxjQUFjLENBQUMsV0FBVyxDQUFDLEtBQUssU0FBUyxDQUFDLEtBQUssRUFDN0QsUUFBUSxFQUFFLE1BQ1IsYUFBYSxDQUFDO1lBQ1osQ0FBQyxXQUFXLEdBQ1YsY0FBYyxDQUFDLFdBQVcsQ0FBQyxLQUFLLFNBQVMsQ0FBQyxLQUFLO2tCQUMzQyxTQUFTLENBQUMsS0FBSztrQkFDZixTQUFTLENBQUMsS0FBSztTQUN0QixDQUFDLEVBRUosU0FBUyxFQUFFLFNBQVMsQ0FBQyxZQUFZLEVBQ2pDLFNBQVMsRUFBRSxTQUFTLENBQUMsWUFBWSxFQUNqQyxNQUFNLEVBQUMsU0FBUyxLQUNaLElBQUksRUFBQSxDQUNSLEVBQ0Y7QUFDSjs7OzsifQ==
